import React, { useState } from "react";

const ConfirmCustomerDisburseModal = ({
  isConfirmCustomerDisburseModalOpen,
  closeConfirmCustomerDisburseModal,
  loanCode,
  customerId,
  amount,
  setAmount,
  loanCustomer,
  mpesaNumber,
  disburseLoan,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  if (!isConfirmCustomerDisburseModalOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
      role="dialog"
      aria-hidden={!isConfirmCustomerDisburseModalOpen}
    >
      <div className="relative bg-white shadow max-w-[60%] h-[72vh] mx-auto p-6 rounded-sm flex flex-col">
        <h2 className="text-xl font-bold mb-4">Disburse Funds</h2>
        <div className="mb-4">
          <p className="text-sm text-black">
            Review all details before proceeding with the loan disbursement.
            Once confirmed, funds will be transferred to the borrower. Use the
            details below to perform a manual disbursement. Once complete, click
            ‘Disbursement Complete’ to continue and fill in reference numbers
            for the audit trail.
          </p>
        </div>

        <div className="flex items-center gap-2 mb-4">
          <div className="mb-4">
            <label className="block font-semibold">Member/Borrower Name</label>
            <input
              type="text"
              value={`${loanCustomer?.customer?.firstname || "N/A"} ${
                loanCustomer?.customer?.middlename || ""
              } ${loanCustomer?.customer?.lastname || ""}`.trim()}
              disabled
              className="bg-transparent outline-none w-[380px] h-[51px] text-black border bg-[#EAEAEA] rounded-md p-4"
            />
          </div>

          <div className="mb-4">
            <label className="block font-semibold">Amount</label>
            <input
              type="text"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              disabled
              className="bg-transparent outline-none w-[380px] h-[51px] text-black border bg-[#EAEAEA] rounded-md p-4"
            />
          </div>
        </div>

        {/* <div className="mb-4">
          <label className="block font-semibold">M-PESA Phone Number</label>
          <input
            type="text"
            value={mpesaNumber}
            disabled
            className="bg-transparent outline-none w-[404px] h-[51px] text-black border bg-[#EAEAEA] rounded-md p-4"
          />
        </div> */}

        {/* Align the buttons at the bottom */}
        <div className="flex flex-col flex-grow justify-end">
          <div className="flex items-center gap-2 mb-4">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => setIsChecked(!isChecked)}
            />
            <label>
              I confirm that the customer details are correct and the amount is
              accurate.
            </label>
          </div>

          <div className="flex justify-between">
            <button
              onClick={closeConfirmCustomerDisburseModal}
              className="bg-[#7FB8EB] px-4 py-2 rounded w-[243px] h-[51px] text-white"
            >
              Cancel
            </button>
            <button
              disabled={!isChecked}
              onClick={() =>
                disburseLoan(amount, loanCode, customerId, mpesaNumber)
              }
              className={`px-4 py-2 rounded w-[243px] h-[51px] ${
                isChecked
                  ? "bg-[#074073] text-white"
                  : "bg-gray-400 text-gray-700"
              }`}
            >
              Disbursement
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmCustomerDisburseModal;
